import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('NavBar'),_c(VMain,{attrs:{"dark":""}},[_c(VContainer,{staticClass:"app pa-7",attrs:{"fluid":""}},[_c(VProgressLinear,{attrs:{"active":_vm.loading,"indeterminate":"","absolute":"","top":""}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('notify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }